export const branchGallerySliderOptions = (instance, options) => {
    let onEvents = {}

    return {
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: false,
        spaceBetween: 0,
        cssMode: true,
        breakpoints: {
            1024: {
                slidesPerView: 3,
                centeredSlides: true,
                cssMode: false,
                loop: true,
            }
        },
        on: onEvents
    }
}